import { useUrlParam } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { $parse, CustomParseFieldProps } from "@opendash/plugin-parse";
import { PointerEdit } from "@opendash/plugin-parse/dist/components/fieldtypes";
import { Button } from "antd";
import React from "react";
import { Order, OrderPlan } from "../types";
import ActiveOrderDrawer from "./ActiveOrderDrawer";

type OrderActionsComponentProps = {
  order: OrderPlan;
  onChange: (order: Order) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
};

const OrderActionsComponent = ({
  order,
  onChange,
  style,
  disabled = false,
}: OrderActionsComponentProps) => {
  const [open, setOpen] = useUrlParam<boolean>("orderOpen", false, "any");
  const [drawerOrderId, setDrawerOrderId] = useUrlParam<string | undefined>(
    "orderId",
    undefined,
    "string"
  );
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 4,
        alignContent: "center",
        alignItems: "center",
        ...style,
      }}
    >
      <Button
        disabled={disabled}
        icon={<Icon icon="fa:play" />}
        onClick={() => {
          const initial = new Order();
          initial.set("ordernr", order.ordernr);
          initial.set("source", order.source);
          initial.set("start", new Date());
          //initial.set("duration", order.setup_time);
          initial.set("order_quantity", order.target_quantity);
          initial.set("setup_time", order.setup_time);
          initial.set("targettime", order.article?.targettime);
          initial.set("article", order.article);
          $parse.ui.createObject("OD3_MES_Order", initial);
        }}
      />

      <Button
        disabled={disabled}
        icon={<Icon icon="fa:list" />}
        onClick={() => {
          setDrawerOrderId(order.get("ordernr"));
        }}
      />
      <ActiveOrderDrawer
        onClose={() => {
          setDrawerOrderId(undefined);
        }}
      />
    </div>
  );
};

export const ParseOrderActionsComponent = ({
  value,
  setValue,
  fieldname,
  parseObject,
  props,
}: CustomParseFieldProps<any>) => {
  console.log(
    "ParseOrderActionsComponent",
    value,
    setValue,
    fieldname,
    parseObject,
    props
  );
  return (
    <>
      {!setValue && (
        <OrderActionsComponent
          order={parseObject as OrderPlan}
          onChange={() => {}}
          disabled={!!setValue}
        />
      )}
      {setValue && (
        <PointerEdit
          isNullable={true}
          value={value}
          setValue={setValue}
          targetClass="OD3_Source"
          isRequired={false}
        />
      )}
    </>
  );
};
export default OrderActionsComponent;
export type { OrderActionsComponentProps };
